// src/components/songEdit/components/MetadataFields.tsx
import React from 'react';

interface MetadataFieldsProps {
  videoLink: string;
  copyright: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const MetadataFields: React.FC<MetadataFieldsProps> = ({
  videoLink,
  copyright,
  onChange
}) => (
  <>
    <div className="song-form__group">
      <label className="song-form__label">Video Link</label>
      <input
        type="url"
        className="song-form__input form-control"
        name="video_link"
        value={videoLink}
        onChange={onChange}
      />
    </div>

    <div className="song-form__group">
      <label className="song-form__label">Copyright</label>
      <input
        type="text"
        className="song-form__input form-control"
        name="copyright"
        value={copyright}
        onChange={onChange}
      />
    </div>
  </>
);